import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "content-wrapper__tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content-header" }
const _hoisted_5 = { class: "flex scroll-content" }
const _hoisted_6 = { class: "flex ml-autoAutoReply autowidth" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "on-desktop" }, "Pause Replies sets", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "on-desktop" }, "Enable Replies sets", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "on-desktop" }, "Remove Replies sets", -1)
const _hoisted_10 = {
  key: 0,
  class: "reply-chip"
}
const _hoisted_11 = {
  key: 1,
  class: "reply-chip"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "table__actions" }

import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useRepliesStore } from '@/stores/replies';
import { useDialogStore } from '@/stores/dialogs';
import { useConfirmModal } from '@/stores/confirm-modal';
import { useUiStore } from '@/stores/ui';
import { useTitle } from '@vueuse/core';
import TheHeader from '@/components/TheHeader.vue';
import VButton from '@/components/VButton.vue';
import VAuthInput from '@/components/VAuthInput.vue';
import VSocialSelect from '@/components/VSocialSelect.vue';
import EmptyBMs from '@/components/EmptyBMs.vue';
import Table from '@/components/Table.vue';
import CreateAutoReplyDialog from '@/components/dialogs/CreateAutoReplyDialog.vue';
import IconButton from '@/components/VIconButton.vue'
import VDatePicker from '@/components/VDatePicker.vue';
import SearchIcon from '@/components/icons/other/SearchIcon.vue';
import AddIcon from '@/components/icons/other/AddIcon.vue';
import EditIcon from '@/components/icons/actions/EditIcon.vue';
import CopyIcon from '@/components/icons/actions/CopyIcon.vue';
import DeleteIcon from '@/components/icons/other/DeleteIcon.vue';
import AssetsCell from '@/components/AssetsCell.vue';
import ViewIcon from '@/components/icons/actions/ViewIcon.vue';
import ViewOffIcon from '@/components/icons/actions/ViewOffIcon.vue';
import { useTabs } from '@/utils/hooks/use-tabs';


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoReplies',
  setup(__props) {

const repliesStore = useRepliesStore()
onMounted(async () => {
  await repliesStore.requestReplies()
})

const searchValue = ref("")

const columns = {
  name: { title: "Replies set", minWidth: 140 },
  replies_set_mode_id: { title: "Type", fallback: "-", minWidth: 40, class: "chips", filters: [
    { title: "Keyword", filter: (item: any) => item.replies_set_mode_id === 1 },
    { title: "Asset", filter: (item: any) => item.replies_set_mode_id === 2 }
  ] },
  keys: { title: "Value", fallback: "-", minWidth: 60, width: 120 },
  assets: { title: "Involved Assets", fallback: "-" },
  comment_count: { title: "Comments", sort: true },
  comment_replies_count: { title: "Replies", sort: true },
  comment_rate: { title: "Replies rate", sort: true },
  actions: { title: "", width: 120 }
}

const { currentTab, tabs } = useTabs([
  { id: "bm", name: "BMs", path: "bms" },
  { id: "pages", name: "Pages", path: "pages" },
  { id: "ad_accounts", name: "Ad accounts", path: "ad-accounts" },
  { id: "campaigns", name: "Ad campaigns", path: "campaigns" },
])

const socialValue = ref<string | null>(null)

const getAssets = (item: any) => {
  if (currentTab.value === "bm") {
    return item.businesses
  }
  if (currentTab.value === "pages") {
    return item.pages
  }
  if (currentTab.value === "ad_accounts") {
    return item.ad_accounts
  }
  if (currentTab.value === "campaigns") {
    return item.campaigns
  }
}

const selected = reactive(new Set<any>())
const dialogStore = useDialogStore()
const addReplySet = () => {
  dialogStore.open(CreateAutoReplyDialog, {})
}

const confirmModal = useConfirmModal()

const edit = (item: any) => {
  dialogStore.open(CreateAutoReplyDialog, { item })
}

const copy = (item: any) => {
  repliesStore.copy(item)
}

const actionPause = computed(() => {
  for (let item of selected) {
    if (item.active) return true
  }
  return false
})

const togglePause = (e: MouseEvent, items: any[]) => {
  const toPause = items.find(item => item.active)
  if (toPause) {
    confirmModal.open(e, `Are you sure you want to pause reply ${items.length === 1? 'set': 'sets'}?`, async () => {
      await repliesStore.disable(items)
      selected.clear()
    })
  } else {
    confirmModal.open(e, `Are you sure you want to enable reply ${items.length === 1? 'set': 'sets'}?`, async () => {
      await repliesStore.enable(items)
      selected.clear()
    })
  }
}

const deleteItem = (e: MouseEvent, item: any) => {
  confirmModal.open(e, "Are you sure you want to delete the selected\n reply set?", async () => {
    await repliesStore.deleteReplies([ item.id ])
  })
}

const deleteItems = (e: MouseEvent) => {
  confirmModal.open(e, "Are you sure you want to delete selected reply sets?", async () => {
    await repliesStore.deleteReplies(Array.from(selected.values()).map((item: any) => item.id))
    selected.clear()
  })
}

const uiStore = useUiStore()
watch([() => uiStore.period, () => uiStore.customDate], async () => {
  await repliesStore.requestReplies()
})

const currentData = computed(() => {
  const arr = repliesStore.replies
  if (currentTab.value === "pages") {
    return arr.filter(item => item.page_ids.length > 0)
  }
  if (currentTab.value === "ad_accounts") {
    return arr.filter(item => item.ad_account_ids.length > 0)
  }
  if (currentTab.value === "campaigns") {
    return arr.filter(item => item.campaign_ids.length > 0)
  }
  return arr
})

useTitle("Auto-Replies | Reply200")


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheHeader, { title: "Auto-Replies" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
          return (_openBlock(), _createElementBlock("button", {
            class: _normalizeClass({ active: _unref(currentTab) === tab.id }),
            onClick: ($event: any) => (currentTab.value = tab.id)
          }, _toDisplayString(tab.name), 11, _hoisted_3))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(VButton, {
            class: "density mr-2",
            onClick: addReplySet
          }, {
            default: _withCtx(() => [
              _createVNode(AddIcon),
              _createTextVNode(" Auto-replies set")
            ]),
            _: 1
          }),
          _createVNode(VSocialSelect, {
            modelValue: socialValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((socialValue).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(VAuthInput, {
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
            icon: SearchIcon,
            placeholder: "Search",
            class: "ml-autoAutoReply light search",
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createVNode(VDatePicker)
        ])
      ]),
      _createVNode(Table, {
        modelValue: selected,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
        columns: columns,
        data: _unref(currentData),
        search: searchValue.value,
        "row-key": "id",
        checkable: "",
        "default-sort": "comment_count",
        loading: !_unref(repliesStore).loaded,
        "hide-stub": _unref(uiStore).showBM,
        "enabled-key": "active"
      }, {
        "alt-header": _withCtx(() => [
          _createVNode(VButton, {
            secondary: "",
            density: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (togglePause($event, Array.from(selected.values()))))
          }, {
            default: _withCtx(() => [
              (_unref(actionPause))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(ViewIcon),
                    _hoisted_7
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(ViewOffIcon),
                    _hoisted_8
                  ], 64))
            ]),
            _: 1
          }),
          _createVNode(VButton, {
            secondary: "",
            density: "",
            class: "ml-1",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (deleteItems($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(DeleteIcon),
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        replies_set_mode_id: _withCtx(({ cell }) => [
          (cell === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Keyword"))
            : (cell === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Asset"))
              : _createCommentVNode("", true)
        ]),
        keys: _withCtx(({ cell }) => [
          (!cell || cell.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "-"))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            style: _normalizeStyle({ marginTop: cell.length > 1? '-8px': 0 })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell, (item) => {
              return (_openBlock(), _createElementBlock("div", null, _toDisplayString(item), 1))
            }), 256))
          ], 4)
        ]),
        assets: _withCtx(({ item }) => [
          _createVNode(AssetsCell, {
            items: getAssets(item)
          }, null, 8, ["items"])
        ]),
        actions: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(IconButton, {
              onClick: ($event: any) => (togglePause($event, [ item ]))
            }, {
              default: _withCtx(() => [
                (item.active)
                  ? (_openBlock(), _createBlock(ViewIcon, { key: 0 }))
                  : (_openBlock(), _createBlock(ViewOffIcon, { key: 1 }))
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(IconButton, {
              onClick: ($event: any) => (edit(item))
            }, {
              default: _withCtx(() => [
                _createVNode(EditIcon)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(IconButton, {
              onClick: ($event: any) => (copy(item))
            }, {
              default: _withCtx(() => [
                _createVNode(CopyIcon)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(IconButton, {
              onClick: ($event: any) => (deleteItem($event, item))
            }, {
              default: _withCtx(() => [
                _createVNode(DeleteIcon)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "data", "search", "loading", "hide-stub"]),
      _createVNode(EmptyBMs)
    ])
  ], 64))
}
}

})